export const GET_INFO = 'contacto_traer_info';
export const LOADING = 'contacto_loading';
export const ERROR = 'contacto_error';